import React from 'react'
import styles from './index.module.css'
import RefreshIcon from '@mui/icons-material/Refresh';

export default function LoadingButton() {
  return (
    <div className={styles.button}>
        <RefreshIcon className={styles.rotating}/>
    </div>
  )
}
